import { CheckboxButtonGroupValue } from "./Button";
import { Card } from "./Card";
import { FoilType } from "./CardFinish"
import { CardRarity } from "./CardRarity";

export type VariantJsonV2 = {
    id: string,
    serial: string,
    altSerial: string,
    imageId: string,
    finish: FoilType,
    variant: CardVariantName,
    products: number[],
    tcgPlayerId: number,
    octgnId: string,
    artists: string[],
    isTempImage: boolean,
    isPrimaryVariant: boolean
}

export type CardVariant = VariantJsonV2 & {
    card: Card,
    opus: number,
    cardNumber: number,
    altOpus: number | undefined,
    altCardNumber: number | undefined,
    altRarity: CardRarity | undefined,
    fullSerial: string
};

export type CardImageVariant = {
    imageId: string,
    variants: CardVariant[]
}

export type CardVariantQuantity = CardVariant & {
    quantity: number
}

export const cardVariantNames = ["Non-Foil", "Foil", "Non-Foil Full Art", "Foil Full Art", "Legacy Foil Full Art", "Signature Foil Full Art"] as const;
export type CardVariantName = typeof cardVariantNames[number];

export function getDefaultCardVariantOptions(): CheckboxButtonGroupValue<CardVariantName>[] {
    return [
        { label: "Non-Foil", data: "Non-Foil", isChecked: false },
        { label: "Foil", data: "Foil", isChecked: false },
        { label: "Non-Foil FA", data: "Non-Foil Full Art", isChecked: false },
        { label: "Foil FA", data: "Foil Full Art", isChecked: false },
        { label: "Legacy", data: "Legacy Foil Full Art", isChecked: false },
        { label: "Signature", data: "Signature Foil Full Art", isChecked: false }
    ]
}

export const VARIANT_SORT_VALUES: Readonly<Record<CardVariantName, number>> = {
    "Non-Foil": 0,
    "Foil": 1,
    "Non-Foil Full Art": 2,
    "Foil Full Art": 3,
    "Legacy Foil Full Art": 4,
    "Signature Foil Full Art": 5
}